import React from "react";
import styles from "./styles.module.scss";
import { Divider } from "antd";

export const DetailTable = ({ data, title }) => {
  return (
    <div>
      <div className={styles.tableWrapper}>
        <div className={styles.hitType}>{title}</div>
        <div className={styles.header}>
          <div
            className={`${styles.columnName}`}
            style={{ justifySelf: "start" }}
          >
            Critical Events
          </div>
          <div className={styles.columnName}>Benchmark Videos</div>
          <div className={styles.columnName}>Average Difference</div>
          <div className={styles.columnName} style={{ justifySelf: "end" }}>
            Median Difference
          </div>
        </div>
        {data?.map((item, i) => (
          <div
            className={styles.singleRow}
            key={item?.title}
            style={{ backgroundColor: i % 2 === 1 ? "#F8F8F8" : "white" }}
          >
            <div className={styles.events}>
              <div className={styles.value1}>{item?.title?.split("-")[0]}</div>
              <div className={styles.separator} />
              <div className={styles.value2}>{item?.title?.split("-")[1]}</div>
            </div>
            <div className={styles.videosCount}>{item.count}</div>
            <div className={styles.average}>
              <div className={styles.value1}>{item?.averageDiff}</div>
              <div className={styles.separator} />
              <div className={styles.value2}>{item?.averageDiffPerc}</div>
            </div>
            <div className={styles.median}>
              <div className={styles.value1}>{item?.mdianDiff}</div>
              <div className={styles.separator} />
              <div className={styles.value2}>{item?.medianDiffPerc}</div>
            </div>
          </div>
        ))}
        <div
          className={styles.singleRowOverall}
          style={{ borderBottom: "none", backgroundColor: "white" }}
        >
          <div className={styles.overallName} style={{ fontWeight: "700" }}>
            Overall Difference
          </div>
          <div className={styles.average}>
            <div className={styles.value1}>{1}</div>
            <div className={styles.separator} />
            <div className={styles.value2}>33%</div>
          </div>
          <div className={styles.median}>
            <div className={styles.value1}>{33}</div>
            <div className={styles.separator} />
            <div className={styles.value2}>33%</div>
          </div>
        </div>
      </div>
    </div>
  );
};
